module.exports = __webpack_public_path__ + "c507e0f702f9df91c6a8fb477d525d64.svg";